<template>
  <div class="home-box main">
    <div v-if="show_yikuhuanbiao">
      <div style="margin-top: 30px;">
        移库换标统计
      </div>
      <Row type="flex" class="mt50 green">
        <Col span="4">
        <p>在库包裹数：</p>
        <h1 class="tc">{{info1.stock_package_count}} 个</h1>
        </Col>
        <Col span="4">
        <p>在库SKU数：</p>
        <h1 class="tc">{{info1.stock_sku_count}}个</h1>
        </Col>
        <Col span="4">
        <p>在库商品数：</p>
        <h1 class="tc">{{info1.stock_product_count}}个</h1>
        </Col>
        <Col span="6" style="background-color: beige;">
        <p>等待上传Label的出库单数：</p>
        <h1 class="tc">{{info1.out_bill_label_count}}个</h1>
        <p><router-link to="/Warehouse/Out" class="fr btn-green">查看</router-link></p>
        </Col>
      </Row>
    </div>
    <div v-if="show_tuihuozhijian">
      <div style="margin-top: 30px;">
        退货质检统计
      </div>
      <Row type="flex" class="mt50 green">
        <Col span="6">
        <p>在库包裹数：</p>
        <h1 class="tc">{{info2.stock_package_count}} 个</h1>
        </Col>
        <Col span="6">
        <p>在库SKU数：</p>
        <h1 class="tc">{{info2.stock_sku_count}}个</h1>
        </Col>
        <Col span="6">
        <p>在库商品数：</p>
        <h1 class="tc">{{info2.stock_product_count}}个</h1>
        </Col>
      </Row>
    </div>
    <div v-if="show_prep">
      <div style="margin-top: 30px;">
        PREP统计
      </div>
      <Row type="flex" class="mt50 green">
        <Col span="6">
        <p>在库包裹数：</p>
        <h1 class="tc">{{info3.stock_package_count}} 个</h1>
        </Col>
        <Col span="6">
        <p>在库SKU数：</p>
        <h1 class="tc">{{info3.stock_sku_count}}个</h1>
        </Col>
        <Col span="6">
        <p>在库商品数：</p>
        <h1 class="tc">{{info3.stock_product_count}}个</h1>
        </Col>
      </Row>
    </div>
    <Row type="flex" class="mt50">
      <Col span="6" class="amount-info">
      <p class="overflow-h">账户余额： <router-link to="/Finance/Recharge" class="fr btn-green">充值</router-link>
      </p>
      <h3 class="tc mt20 mb20 f20"> $ {{account.current_amount}}</h3>
      <p class="overflow-h">待结算费用： <router-link to="/Finance/BillDetails" class="fr btn-green">查看明细</router-link>
      </p>
      <h3 class="tc mt30 f20"> $ {{account.total_unsettled_fee}}</h3>
      <p class="tc f14 red mt20">*请尽快支付账单，以免影响发货*</p>
      </Col>
      <Col span="12" class="w-info f16">
      <div class="item">
        <h2>
          <i class="icon-noc mr20"></i>
          <span class="b f20">{{houseInfo.warehouse_name}}</span>
        </h2>
        <p>ADD:&nbsp;&nbsp;{{houseInfo.address}}</p>
        <p>City:&nbsp;&nbsp;{{houseInfo.city}}</p>
        <p>State:&nbsp;&nbsp;{{houseInfo.state}}</p>
        <p>Postcode:&nbsp;&nbsp;{{houseInfo.zipcode}}</p>
      </div>
      <div class="item pt40">
        <h2 class="flex">
          <i class="icon-user mr20"></i>
          <span class="b f20" style="width: 290px;">{{houseInfo.manager}} <span style="color: red; ">(此处添加对应业务的子编号)</span></span>
        </h2>
        <p><span class="b">{{houseInfo.contact_phone}}</span></p>
      </div>
      </Col>
    </Row>
  </div>
</template>

<script>
  import Paging from '@/components/common/paging'
  export default {
    components: {
      Paging
    },
    name: 'Home',
    data() {
      return {
        info1: {
        },
        info2: {
        },
        info3: {
        },
        account: {
          current_amount: 0,
          total_unsettled_fee: 0,
        },
        houseInfo: {}, //仓库信息
        table_data: { //列表数据
          columns: [],
          data: []
        },
        timer: null,
        src: '',
        screen_data: { //传入接口的搜索条件
          status: 30,
          warehouse_id: '',
          pageNum: 1,
          pageSize: 10,
        },
        page_data: { //分页数据
          pageTotal: 0, //总页数
          dataTotal: 0, //总条数
          pageIndex: 1, //当前页数
          pageCount: 8 //页面最多显示几个分页组
        },
        show_yikuhuanbiao: false,//移库换标
        show_tuihuozhijian: false, //退货质检
        show_prep: false,//PREP统计
      }
    },
    methods: {
      init() {
        this.getBiztype(); //业务类型
        this.$axios.get('/dashboard/warehouse/count', {
          params: {
            warehouse_id: this.screen_data.warehouse_id,
            biz_type: 1,
            client_code: this.screen_data.client_code
          }
        }).then(res => {
          if (res.success) {
            this.info1 = res.data
          }
        });
        this.$axios.get('/dashboard/warehouse/count', {
          params: {
            warehouse_id: this.screen_data.warehouse_id,
            biz_type: 2,
            client_code: this.screen_data.client_code
          }
        }).then(res => {
          if (res.success) {
            this.info2 = res.data
          }
        });
        this.$axios.get('/dashboard/warehouse/count', {
          params: {
            warehouse_id: this.screen_data.warehouse_id,
            biz_type: 3,
            client_code: this.screen_data.client_code
          }
        }).then(res => {
          if (res.success) {
            this.info3 = res.data
          }
        });
        this.$axios.get('/dashboard/client/account').then(res => {
          if (res.success) {
            this.account = res.data
          }
        });
      },
      getBiztype(){ //业务类型
        this.$axios.get("/client/biz/type").then(res => {
          if(res.data&&res.data.length){
              //0中转补货， 1-移库换标， 2- 退货质检， 3- PREP， 4-中转发货；
            let biz_types = res.data.map(v=>v.biz_type);
            if(biz_types.includes(1)){
              this.show_yikuhuanbiao = true;
            }
            if(biz_types.includes(2)){
              this.show_tuihuozhijian = true;
            }
            if(biz_types.includes(3)){
              this.show_prep = true;
            }
          }
        });
      },
      getHouseList() { //仓库列表
        this.$axios.get("/warehouse/list").then(res => {
          if (res.success && res.data && res.data.length > 0) {
            let d = res.data.find(item => item.warehouse_id == this.screen_data.warehouse_id)
            this.houseInfo = d
          }
        });
      },
    },
    created() {
      this.screen_data.warehouse_id = localStorage.getItem('warehouse_id');
      this.screen_data.client_code = localStorage.getItem('client_code') || '';
      if (this.screen_data.warehouse_id) {
        this.getHouseList();
      } else {
        this.$Message.info('请选择仓库')
      }
      console.log(this.$store.state.houseList)
      this.init();
    },
    destroyed() {

    },
  }
</script>

<style>
  .home-box .ivu-col {
    font-size: 16px;
    padding: 30px;
    margin-left: 3%;
    background: rgba(247, 249, 250, 1);
    font-weight: bold;
  }

  .home-box .ivu-col h1 {
    font-size: 30px;
    font-weight: bold;
    padding: 30px 0;
  }

  .w-info {
    display: flex;
  }

  .w-info .item {
    width: 49%;
  }

  .w-info .item p {
    padding: 10px 0 0 60px;
  }

  .w-info .b {
    font-weight: bold;
    font-size: 20px;
  }

  .icon-noc {
    display: inline-block;
    width: 18px;
    height: 19px;
    background: url(../../../static/img/icon-noc.svg) no-repeat;
    background-size: 100% 100%;
  }

  .icon-user {
    display: inline-block;
    width: 33px;
    height: 33px;
    background: url(../../../static/img/icon-user.svg) no-repeat;
    background-size: 100% 100%;
    vertical-align: middle;
  }

  .flex {
    display: flex;
  }

  .amount-info a {
    color: #FFFFFF;
    background-color: #00B212;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue